import Image from 'next/image';
import styles from './AboutSection.module.css';
import { ISummary } from '@/interfaces/IDesignCity';
type props = {
    aboutData: ISummary
}
export function AboutSection({ aboutData }: props) {
    return (
        <section className="section bgWhite">
            <div className="containerFull">
                <div className={styles.interComsndsecm}>
                    <div className={styles.interMainleft}>
                        <h2 className="font26 f500 text222 mb16 fontSM20">About Interior <span
                            className="textpink">Company</span></h2>
                        <div className={styles.aboutSecondSecSubHead}>
                            <p className="lineHeight20 font16 mb16 fontSM14">From conception to bringing the ideal balance of functionality and style, we breathe life into your dream homes with our interior design services in Dubai.</p>
                        </div>
                        <div className={styles.intMainleftLowebox}>
                            <div className={styles.intLowtiliner}>
                                <figure><Image width={44} height={44} className="img-responsive" src="/assets/images/Duabi-sofa.svg" alt="Duabi-sofa" /></figure>
                                <div className={styles.inLowetiletext}>
                                    <span className="font30 fbold text222 fontSM16">{aboutData.closedProjects}+</span>
                                    <span className="font12 fontsmlo">Home Delivered</span>
                                </div>
                            </div>
                            <div className={styles.intLowtiliner}>
                                <figure><Image width={44} height={44} className="img-responsive" src="/assets/images/Duabi-scale.svg" alt="Duabi-scale" /></figure>
                                <div className={styles.inLowetiletext}>
                                    <span className="font30 fbold text222 fontSM16">{aboutData.projectsUnderExecutionPhase}+</span>
                                    <span className="font12 fontsmlo">Projects In Execution Phase</span>
                                </div>
                            </div>
                            <div className={styles.intLowtiliner}>
                                <figure><Image width={44} height={44} className="img-responsive" src="/assets/images/Duabi-paint.svg" alt="Duabi-paint" /></figure>
                                <div className={styles.inLowetiletext}>
                                    <span className="font30 fbold text222 fontSM16">{aboutData.projectsInDesignPhase}+</span>
                                    <span className="font12 fontsmlo">Homes Under Design Phase</span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className={styles.interMinrgtbox}>
                        <div className={styles.interRighintiles}>
                            <figure><Image width={312} height={228} src="/assets/images/Duabi2ndsec1stimg.png" alt="Duabi2ndsec1stimg" /></figure>
                        </div>
                        <div className={styles.interRighintiles}>
                            <figure><Image width={312} height={228} src="/assets/images/duabisndsec2ndimg.png" alt="duabisndsec2ndimg" /></figure>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}